<template>
	<section :class="{'login': true, 'zhaonaxue-bg-img': zhaonaxue}">
		<div class="content">
			<div class="header">
				<div class="logo">
					<img :src="logo" alt />
				</div>
			</div>
			<div class="main">
				<div v-if="!zhaonaxue" class="bg">
					<img src="../../assets/images/login/bg@2x.png" alt />
				</div>
				<div :class="{card: !zhaonaxue, 'zhaonaxue-position': zhaonaxue}">
					<div class="title" v-if="zhaonaxue">{{$t('module_login.zhaonaxue_admin')}}</div>
					<div class="title" v-else>{{$t('module_login.title')}}</div>
					<div class="body">
						<el-form>
							<el-form-item>
								<el-input type="text" v-model.trim="username" :placeholder="$t('module_login.username')">
									<i slot="prefix" class="el-input__icon icon icon-user"></i>
								</el-input>
							</el-form-item>
							<el-form-item>
								<el-input :type="type" :placeholder="$t('module_login.password')" v-model.trim="password">
									<i slot="prefix" class="el-input__icon icon icon-password"></i>
									<i
										slot="suffix"
										class="icon-eye-close icon el-input__icon"
										@click="showPassword"
										v-if="!display"
									></i>
									<i slot="suffix" class="icon-eye-open icon el-input__icon" @click="showPassword" v-else></i>
								</el-input>
							</el-form-item>
							<!-- 新增验证码 -->
							<el-form-item>
								<div class="code_box">
									<el-input type="text" v-model.trim="verificationCode" :placeholder="$t('验证码')"></el-input>
									<!-- 图形码 -->
									<div class="graphic_code" @click="refreshCode()">
										<xb-verification-code :identifyCode="identifyCode"></xb-verification-code>
									</div>
								</div>
							</el-form-item>
							<el-form-item size="large">
								<el-button
									style="width: 100%"
									type="primary"
									ref="loginBtn"
									:loading="loading"
									@click="onSubmit"
								>{{ $t('login') }}</el-button>
							</el-form-item>
						</el-form>
					</div>
				</div>
			</div>
      <div class="language-options">
        <label>{{ $t('中文') }}<input type="radio" v-model="language" value="zh_CN"/></label> &nbsp;|&nbsp;
        <label>{{ $t('English') }}<input class="label_language" type="radio" v-model="language" value="en"/></label>   |&nbsp;
        <label>{{ $t('Malaysia') }}<input class="label_language" type="radio" v-model="language" value="ms"/></label>

      </div>
			<div :class="{'footer': !zhaonaxue, 'zhaonaxue-footer': zhaonaxue}">
				<ul class="links" v-if="links.length">
					<li class="link" v-for="item in links" :key="item.url">
						<a :href="item.url" target="_blank">{{item.title}}</a>
					</li>
				</ul>
				<p class="zhaonaxue-copy" v-if="zhaonaxue">
					<!-- <span class="copy-desc">版权所有 保留一切权利</span>
					<a href="http://www.beian.miit.gov.cn">备案号：粤ICP备14074643号-6</a> -->
				</p>
				<p class="copyright" v-else>ICP备案号：粤ICP备14074643号-1</p>
			</div>
		</div>
		<div class="blank"></div>
	</section>
</template>

<script>
import { mapActions } from 'vuex';
import { throttle } from '@/utils';
import api from '@/api';
import config from '@/config';
import xbVerificationCode from '@/components/base/xb-verification-code/index.vue';

export default {
	name: 'login',
	data() {
		return {
			zhaonaxue: false,
			username: '',
			password: '',
			type: 'password',
			loading: false,
			display: false,
			num: 1,
			links: [],
			verificationCode: '', // 用户输入的验证码
			identifyCode: '', // 验证码
			captchaKey: '', // 验证码key
      language: this.$i18n.locale
		};
	},
  watch: {
    language (newVal) {
      this.$i18n.locale = newVal;
      localStorage.setItem('lang', newVal);
    }
  },
	computed: {
		logo() {
			return this.$store.state.user.appInfo.logo;
		}
	},
	created() {
		this._createCode();
		if (window.location.hostname === config.hostName) {
			this.zhaonaxue = true;
		}
	},
	mounted() {
		let vm = this;
		// 回车登录
		document.onkeydown = function(event) {
			if (event.keyCode === 13) {
				vm.$refs.loginBtn.handleClick();
			}
		};
	},

	methods: {
		...mapActions(['loginByUsername', 'loginTokenOld']),
		/**
		 * 点击展示/隐藏密码
		 */
		showPassword() {
			this.display = !this.display;
			if (this.display) {
				this.type = 'text';
			} else {
				this.type = 'password';
			}
		},
		/**
		 * 点击登录
		 */
		onSubmit: throttle(function() {
			localStorage.setItem('xb_host', location.host);
			this._login();
		}, 3000),
		/**
		 * 登录
		 */
		_login() {
			if (this.username === '') {
				this.$message({
					type: 'warning',
					message: this.$t('请先输入用户名')
				});
				return;
			}
			if (this.password === '') {
				this.$message({
					type: 'warning',
					message: this.$t('请先输入密码')
				});
				return;
			}
			if (this.verificationCode === '') {
				this.$message({
					type: 'warning',
					message: this.$t('请输入验证码')
				});
				return;
			}
			this.loading = true;
			let {
				username,
				password,
				loginTokenOld,
				$router,
				$message,
				loginByUsername
			} = this;
			let data = {
				username: window.btoa(username),
				password: window.btoa(password),
				key: this.captchaKey,
				code: this.verificationCode
			};
			loginByUsername(data)
				.then(() => {
					loginTokenOld(data)
						.then(() => {
							$router.push({
								path: '/'
							});
						})
						.catch(err => {
							if (err.message) {
								$message({
									type: 'error',
									message: this.$t(err.message),
									center: true
								});
							}
						});
				})
				.catch(err => {
					console.log('err', err);
					if (err.message) {
						$message({
							type: 'error',
							message: this.$t(err.message),
							center: true
						});
						this._createCode();
						this.verificationCode = '';
					}
				})
				.finally(() => {
					this.loading = false;
				});
		},
		/**
		 * 旧版登录
		 */
		_loginByUsernameOld(data) {
			api.user
				.loginByUsernameOld(data)
				.then(res => {
					console.log(res);
				})
				.catch(err => {
					console.error(err);
				});
		},
		/**
		 *旧版登录token
		 */
		_loginTokenOld(data) {
			api.user
				.loginTokenOld(data)
				.then(res => {
					console.log('took', res.data);
				})
				.catch(err => {
					console.log('tool-err', err);
				});
		},
		//获取验证码创建
		_createCode() {
			api.user
				.createCode()
				.then(res => {
					if (res && res.status === 0) {
						let dataList = JSON.parse(window.atob(res.data.captcha));
						this.identifyCode = dataList.captcha;
						// 本地运行时 自动输入验证码
						if (location.hostname === 'localhost') {
							this.verificationCode = this.identifyCode;
						}
						this.captchaKey = dataList.captcha_key;
					}
				})
				.catch(err => {
					console.log(err);
					this.$message({
						type: 'error',
						message: '获取验证码失败，请刷新重试'
					});
				});
		},
		// 更新验证码
		refreshCode() {
			let data = {
				captcha_key: this.captchaKey
			};
			api.user
				.refreshCode(data)
				.then(res => {
					if (res && res.status === 0) {
						let captcha = JSON.parse(window.atob(res.data.captcha));
						this.identifyCode = captcha.captcha;
						// 本地运行时 自动输入验证码
						if (location.hostname === 'localhost') {
							this.verificationCode = this.identifyCode;
						}
						this.captchaKey = captcha.captcha_key;
					} else {
						this.$message({
							type: 'warning',
							message: res.message
						});
					}
				})
				.catch(err => {
					console.log(err);
					this.$message({
						type: 'error',
						message: '获取验证码失败，请刷新重试'
					});
				});
		}
	},
	components: {
		xbVerificationCode
	}
};
</script>

<style lang="scss" scoped>
.login {
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
	background-color: #ffffff;
	.content {
		flex: 1;
		width: 100%;
		height: 100%;
		.header {
			display: flex;
			align-items: center;
			height: 78px;
			background-color: #ffffff;
			.logo {
				width: 150px;
				margin-left: 30px;
				img {
					width: 100%;
				}
			}
		}
		.main {
			position: relative;
			width: 100%;
			max-height: 474px;
			.bg {
				width: 100%;
				height: 100%;
				min-height: 300px;
				img {
					display: block;
					width: 100%;
				}
			}
			.card {
				position: absolute;
				right: 30%;
				top: 50%;
				transform: translateY(-50%);
				width: 300px;
				background-color: #ffffff;
				.title {
					width: 100%;
					height: 58px;
					line-height: 58px;
					text-align: center;
					background-color: #f9faff;
					font-size: $-font-size-b;
					color: $-color-text-secondary;
				}
				.body {
					width: 260px;
					padding: 24px 20px;
				}
			}
			.zhaonaxue-position {
				margin: calc(10% - 78px) 25% 0 auto;
				float: right;
				width: 300px;
				border-radius: 8px;
				background-color: #ffffff;
				.title {
					width: 100%;
					height: 58px;
					line-height: 58px;
					text-align: center;
					background-color: #f9faff;
					font-size: $-font-size-b;
					color: $-color-text-secondary;
					border-radius: 8px 8px 0 0;
				}
				.body {
					width: 260px;
					padding: 24px 20px;
				}
			}
		}
		.footer {
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			width: 100%;
			// height: 92px;
			color: $-color-text-info;
			font-size: $-font-size-s;
			.links {
				display: flex;
				padding-bottom: 19px;
				.link {
					padding: 0 14px;
					border-left: 1px solid $-color-text-info;
					&:first-child {
						border-left: none;
					}
					a {
						color: $-color-text-info;
					}
				}
			}
			.copyright {
				line-height: 1;
				padding: 20px 0;
			}
		}
		.zhaonaxue-footer {
			width: 100%;
			position: fixed;
			left: 0;
			bottom: 30px;
			text-align: center;
			.zhaonaxue-copy {
				line-height: 180%;
				font-size: 12px;
				a {
					padding-left: 15px;
					display: inline-block;
					text-decoration: none;
					color: #551a8b;
				}
			}
		}
	}
	.blank {
		width: 100%;
		height: 40.5%;
	}
  .language-options {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 50px;
    color: rgb(153,153,153);
    label{
      input{
        margin-left: 3px;
        vertical-align: middle;
      }
      .label_language{
        margin-left: 10px;
      }
    }
  }
  .language-options label {
    display: inline-block;
    margin-right: 5px;
  }
}
.zhaonaxue-bg-img {
	background: url('../../assets/images/login/zhaonaxue.png') no-repeat;
	background-size: cover;
	background-position: 0 78px;
}
@media screen and (max-width: 1024px) {
	.login {
		.content {
			.main {
				.card {
					right: 15%;
					width: 250px;
					.body {
						width: 190px;
					}
				}
				.zhaonaxue-position {
					right: 15%;
					width: 250px;
					.body {
						width: 190px;
					}
				}
			}
		}
	}
}
@media screen and (min-width: 1024px) and (max-width: 1440px) {
	.login {
		.content {
			.main {
				.card {
					right: 26%;
					width: 250px;
					.body {
						width: 210px;
					}
				}
				.zhaonaxue-position {
					right: 26%;
					width: 250px;
					.body {
						width: 210px;
					}
				}
			}
		}
	}
}
.code_box {
	display: flex;
	justify-content: space-between;
	.el-input {
		margin-right: 20px;
	}
	.graphic_code {
		height: 36px;
		cursor: pointer;
	}
}
</style>
